import React from "react";
import { useTranslation } from "react-i18next";

function Header() {
  const { t } = useTranslation("homepage");
  const sliderData = t("header.slider", { returnObjects: true });

  return (
    <header className="tc-header-style1">
      <div className="header-slider">
        <div className="swiper-wrapper">
          {sliderData.map((item, i) => (
            <div key={i} className="swiper-slide">
              <div className="slider-card">
                <div className="img">
                  <img
                    src={`/home1/assets/img/slider/${i + 1}.jpg`}
                    alt=""
                    className="img-cover"
                  />
                </div>
                <div className="info section-padding-x pb-70">
                  <div className="row align-items-end gx-5">
                    <div className="col-lg-6 offset-lg-2">
                      {item.title.toLowerCase() === "botanicheska 302" ? (
                        <h1 style={{ fontFamily: "TheSeasons" }}>
                          BOTANICHESKA 302
                        </h1>
                      ) : (
                        <h1 style={{ fontFamily: "Montserrat" }}>
                          {item.title}
                        </h1>
                      )}

                      <h5 className="fsz-30 mt-30 fw-400">{item.subTitle}</h5>
                    </div>
                    <div className="col-lg-3">
                      <div className="cont pb-30">
                        <div className="text fsz-17 fw-300 lh-4">
                          {item.desc
                            .split(/(botanicheska 302)/i)
                            .map((part, index) =>
                              part.toLowerCase() === "botanicheska 302" ? (
                                <span
                                  key={index}
                                  style={{
                                    fontFamily: "TheSeasons",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {part}
                                </span>
                              ) : (
                                part
                              )
                            )}
                        </div>

                        <a
                          href={item.buttonLink || "/innerpages/portfolio"}
                          className="butn border rounded-pill mt-60 hover-bg-white"
                        >
                          <span>
                            {item.button}
                            <i className="small ms-1 ti-arrow-top-right"></i>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="slider-controls">
          <div className="swiper-button-prev"></div>
          <div className="swiper-button-next"></div>
        </div>
        <div className="swiper-pagination"></div>
      </div>
    </header>
  );
}

export default Header;
